import { render, staticRenderFns } from "./Headerclient.vue?vue&type=template&id=fe8cca52"
import script from "./Headerclient.vue?vue&type=script&lang=js"
export * from "./Headerclient.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports